// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import styled from '@emotion/styled';
import { SyntheticEvent, useCallback } from 'react';
import Link from 'presentations/views/components/atoms/Link';
import Logo from 'presentations/views/components/atoms/Logo';

import { fontSize, mediaMax, spacing } from 'presentations/views/styles';
import { gray01, primary } from 'presentations/views/styles/color';
import LanguageSelect from 'presentations/views/components/molecules/LanguageSelect';
import { useRouter } from 'next/router';
import { homePath } from 'presentations/routes/path';
import { useFormFooter } from './hooks';
import { ViewerItem } from 'presentations/api/schema/user';
import InquiryFormDialog from 'presentations/views/components/organisms/InquiryFormDialog';
import { FormPageItem } from 'presentations/api/schema/form';

interface Props {
  viewer: ViewerItem | null;
  form: FormPageItem;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const { state, actions } = useFormFooter({
    form: props.form,
    viewer: props.viewer,
  });
  const router = useRouter();
  const onChangeLocale = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      router.push(router.asPath, undefined, { locale: e.currentTarget.value });
    },
    [router],
  );

  return (
    <Container>
      <LinkList>
        <LinkListLink onClick={actions.onClickInquiry}>
          <TeamLinkTitle>{t('Inquiry Link')}</TeamLinkTitle>
        </LinkListLink>
        <LanguageSelect onChangeLocale={onChangeLocale} />
      </LinkList>
      {props.form.isShowPromotion && (
        <LogoContainer>
          <Link href={homePath()}>
            <Logo variant="gray" />
          </Link>
        </LogoContainer>
      )}
      {state.isShowingInquityForm && (
        <InquiryFormDialog
          onSubmit={actions.onSubmitInquiry}
          onClose={actions.onCloseInquiry}
          color={props.form.color}
          isLightColor={state.isLightColor}
          isCompanyHidden={false}
          isCompanyRequired={false}
          email={state.email}
          message={state.message}
          name={state.name}
          company={state.company}
          errors={state.errors}
          isLoading={state.isLoading}
          onChange={actions.onChange}
          onBlur={actions.onBlur}
        />
      )}
    </Container>
  );
}
const Container = styled.div`
  ${mediaMax.tablet} {
    margin-bottom: ${spacing(24)};
    padding: 0 ${spacing(16)};
  }
`;
const LinkList = styled.div`
  display: flex;
  justify-content: center;
  ${mediaMax.tablet} {
    flex-wrap: wrap;
  }
`;
const LinkListLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${gray01};
  margin-right: ${spacing(16)};
  &:hover {
    color: ${primary};
  }
  ${mediaMax.smartphone} {
    padding: ${spacing(8)} 0;
  }
`;
const LogoContainer = styled.div`
  margin-top: ${spacing(24)};
  text-align: center;
`;
const TeamLinkTitle = styled.span`
  font-size: ${fontSize(12)};
`;
